(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marquee-annoucement"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const marquees = document.querySelectorAll('.js-marquee');
  
  marquees.forEach(function(marquee) {
    // Get the speed setting from data attribute
    const speed = parseInt(marquee.getAttribute('data-speed')) || 15;
    
    // Set the animation duration based on speed (higher number = slower animation)
    // Use a base duration of 450000ms and adjust based on speed setting
    const duration = 450000 / speed;
    
    // Apply duration directly to the element's style
    marquee.style.animationDuration = duration + 'ms';
    
    // Clone all items to ensure continuous scrolling
    const originalItems = Array.from(marquee.children);
    
    if (originalItems.length === 0) return; // Skip if no items
    
    // Make sure we have enough items to fill the container and then some
    // Clone as many times as needed to ensure continuous scrolling
    const minItemsNeeded = Math.ceil(window.innerWidth / (originalItems[0].offsetWidth * originalItems.length)) * 4;
    for (let i = 0; i < minItemsNeeded; i++) {
      originalItems.forEach(function(item) {
        const clone = item.cloneNode(true);
        marquee.appendChild(clone);
      });
    }
    
    // Handle icon fallbacks if SVGs don't render properly
    setTimeout(() => {
      marquee.querySelectorAll('.marquee-icon').forEach(icon => {
        const svg = icon.querySelector('svg');
        if (!svg || svg.getBoundingClientRect().width < 2) {
          const iconType = icon.getAttribute('data-icon-type');
          const iconColor = icon.getAttribute('data-icon-color');
          const iconSize = parseInt(icon.getAttribute('data-icon-size')) || 16;
          
          let textIcon = '◆'; // Default diamond
          
          if (iconType === 'crystal') textIcon = '◆';
          if (iconType === 'amethyst') textIcon = '◇';
          if (iconType === 'moon') textIcon = '☾';
          if (iconType === 'chakra') textIcon = '◎';
          if (iconType === 'lotus') textIcon = '✿';
          
          icon.innerHTML = `<span style="color: ${iconColor}; font-size: ${iconSize}px;">${textIcon}</span>`;
        }
      });
    }, 500);
    
    // Adjust for window resize
    window.addEventListener('resize', function() {
      // Recalculate how many clones we need
      const currentItems = marquee.children.length;
      const itemWidth = originalItems[0].offsetWidth;
      const visibleWidth = window.innerWidth;
      
      // Determine if we need more clones
      const neededItems = Math.ceil(visibleWidth / itemWidth) * 4;
      
      if (neededItems > currentItems) {
        // Add more clones if needed
        for (let i = 0; i < neededItems - currentItems; i++) {
          const itemToClone = originalItems[i % originalItems.length];
          const clone = itemToClone.cloneNode(true);
          marquee.appendChild(clone);
        }
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
